import { jsx as _jsx } from "react/jsx-runtime";
import { isEmptyArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
import { getKeyCodeForEvent, KeyCode } from '../../utils/key-code';
import { AccordionContextInstance } from './types/context';
const b = bemClassBuilder('v-accordion');
/**
 * Renders an accordion.
 */
export const Accordion = observer(props => {
    const { className, headingLevel, expandIconName, children } = props;
    const [focusedSectionId, setFocusedSectionId] = useState();
    const [sectionIds, setSectionIds] = useState([]);
    const sectionIdsRef = useRef([]);
    const addSectionId = (sectionId) => {
        sectionIdsRef.current = [...sectionIdsRef.current, sectionId];
    };
    useEffect(() => {
        setSectionIds(sectionIdsRef.current);
    }, []);
    const removeSectionId = (sectionId) => {
        const sectionsWithMatchingId = sectionIds.find(id => id === sectionId);
        const updatedSectionIds = sectionIds.filter(id => id !== sectionsWithMatchingId);
        setSectionIds(updatedSectionIds);
    };
    // Handles keys for accessibility
    const handleKeyDown = (e) => {
        if (!focusedSectionId)
            return;
        const focusedSectionIndex = sectionIds.indexOf(focusedSectionId);
        const sectionIdsCount = sectionIds.length;
        if (isEmptyArray(sectionIds) || focusedSectionIndex === -1)
            return;
        const firstSection = sectionIds[0];
        const lastSection = sectionIds[sectionIds.length - 1];
        const nextSectionIndex = (focusedSectionIndex + 1) % sectionIdsCount;
        const previousSectionIndex = (focusedSectionIndex + sectionIdsCount - 1) % sectionIdsCount;
        const nextSection = sectionIds[nextSectionIndex];
        const previousSection = sectionIds[previousSectionIndex];
        switch (getKeyCodeForEvent(e)) {
            case KeyCode.DownArrow:
                setFocusedSectionId(nextSection);
                break;
            case KeyCode.UpArrow:
                setFocusedSectionId(previousSection);
                break;
            case KeyCode.Home:
                setFocusedSectionId(firstSection);
                break;
            case KeyCode.End:
                setFocusedSectionId(lastSection);
                break;
            default:
        }
    };
    const accordionContextValue = {
        headingLevel,
        expandIconName,
        addSectionId,
        removeSectionId,
        focusedSectionId,
        setFocusedSectionId: sectionId => setFocusedSectionId(sectionId)
    };
    return (_jsx(AccordionContextInstance.Provider, Object.assign({ value: accordionContextValue }, { children: _jsx("div", Object.assign({ className: b.block(undefined, className), onKeyDown: handleKeyDown }, { children: children })) })));
});
Accordion.displayName = 'Accordion';
